module.exports = __webpack_public_path__ + "img/facts-all_1924.6d2092da.png";